// Ikony produktů v Analytice. Klíč posílá backend (_lib/analytikaData.cjs).
import { Trees, Dumbbell, Salad, ChefHat, ListChecks, ClipboardList, Smartphone, Target } from "lucide-react";
export const IKONY_PRODUKTU = { trees: Trees, dumbbell: Dumbbell, salad: Salad, "chef-hat": ChefHat, "list-checks": ListChecks, clipboard: ClipboardList, smartphone: Smartphone };
export const ikonaProduktu = (k) => IKONY_PRODUKTU[k] || Target;
